
import { defineComponent } from 'vue'
import LoaderSpinner from '@/components/common/LoaderSpinner.vue'
import { constants } from '@/constants'

export default defineComponent({
  name: 'AsahiPopup',
  components: {
    LoaderSpinner
  },
  props: {
    open: Boolean,
    isPadding: Boolean,
    options: Array
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  },
  methods: {
    closePopup () {
      this.$emit('update:open', false)
    },
    navigateToPath (link: any) {
      this.$gtm.trackEvent({
        event: 'click_interaction',
        action: link.label,
        component: 'header'
      })

      this.onClickMenuItem(link.href || link.link || '')
    },
    onClickMenuItem (link: string) {
      const regex = /^(http|https)/
      if (link.match(regex)) {
        window.open(link, '_blank') // Open external links in a new tab
      } else {
        this.$router.push(link) // Internal navigation
      }
    },
    handleMenuClick (item: any) {
      if (item.name === 'Log Out') {
        this.$gtm.trackEvent({
          event: 'click_interaction',
          action: 'Log Out',
          component: 'header'
        })
        this.userLogout()
      } else if (item?.name === 'Academy') {
        this.$gtm.trackEvent({
          event: 'click_interaction',
          action: item?.name,
          component: 'header'
        })

        const spName = this.getSPName(item.name)

        // Constants holding cookie names
        const loginCookieName = constants.saml.loginCookie
        const loginCookieSkName = constants.saml.loginCookieSk

        // Read actual cookie value
        const loginToken = spName.startsWith('sk')
          ? this.getCookie(loginCookieSkName)
          : this.getCookie(loginCookieName)

        const redirectRaw = 'https://plzensky-prazdroj.client-interface.scormium.com/Saml/acs'
        const redirectURL = encodeURIComponent(redirectRaw)

        const baseSSOUrl = 'https://fidm.eu1.gigya.com/saml/v2.0/4_2ygDN9xuqv8jgMFNO9FkMQ/idp/sso/init'
        const finalUrl = `${baseSSOUrl}?spName=${encodeURIComponent(spName)}&redirectURL=${redirectURL}&loginToken=${encodeURIComponent(loginToken ?? '')}`

        if (loginToken) {
          window.location.href = finalUrl
        } else {
          console.warn('Login token not found. Aborting redirect.')
        }
      } else if (item?.name === 'Pub Menu') {
        this.$gtm.trackEvent({
          event: 'click_interaction',
          action: item?.name,
          component: 'header'
        })
        window.gigya.fidm.saml.initSSO({
          spName: this.getSPName(item?.name),
          redirectURL: item.href
        })
      }
    },

    // Helper to get cookie value
    getCookie (name: string): string | null {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      return match ? decodeURIComponent(match[2]) : null
    },
    userLogout () {
      this.isLoading = true

      const params = {
        UID: this.user.UID,
        callback: this.handleLogout
      }
      window.gigya.accounts.logout(params)
    },
    handleLogout () {
      this.$store.dispatch('logout')
      this.isLoading = false
      window.location.reload()
    },
    getSPName (name: string) {
      let spName = ''
      if (name === 'Academy') {
        spName = this.user.country === 'SVK' ? 'skELearning' : 'eLearning'
      }
      if (name === 'Pub Menu') {
        spName = this.user.country === 'SVK' ? 'skPubMenu' : 'pubMenu'
      }
      return spName
    }
  }
})
